import { StyleSheet } from "@react-pdf/renderer";
import VoTheme from "ui/theme/vocollege2";

export const styles = StyleSheet.create({
  root: {
    alignItems: "center",
    // border: `1px solid ${VoTheme.palette.grey[100]}`,
    display: "flex",
    flexDirection: "column",
    // height: "22%",
    justifyContent: "center",
    // marginLeft: "auto",
    // marginRight: "auto",
    // padding: VoTheme.spacing(1),
    // width: "22%",
  },
  logoPlaceholderTitle: {},
  logoPlaceholderSubtitle: {
    color: VoTheme.palette.common.white,
  },
});
